import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Clock, User, BookOpen } from "lucide-react";

export default function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 max-w-3xl mx-auto lg:mx-0 lg:max-w-none">
      <div>
        <h1 className="text-2xl sm:text-3xl font-display font-semibold" data-testid="courses-page-title">دوراتي</h1>
        <p className="text-muted-foreground mt-2 text-sm sm:text-base">جميع الدورات التي تملك الوصول إليها.</p>
      </div>

      {loading ? (
        <div className="text-center text-muted-foreground py-12">جاري التحميل...</div>
      ) : courses.length === 0 ? (
        <div className="p-12 border border-dashed rounded-xl text-center text-muted-foreground" data-testid="courses-empty">
          لا توجد دورات مسجّلة بعد. تظهر الدورات تلقائيًا بعد الشراء أو منحها من الإدارة.
        </div>
      ) : (
        <div className="grid gap-5 lg:grid-cols-2 xl:grid-cols-3">
          {courses.map((c) => (
            <Card key={c.id} className="overflow-hidden hover:-translate-y-1 transition-transform" data-testid={`course-card-${c.id}`}>
              <img src={c.cover_image} alt={c.title} className="w-full aspect-square object-cover" />
              <CardContent className="p-5 space-y-4">
                <div>
                  <h3 className="font-display font-semibold text-lg line-clamp-1">{c.title}</h3>
                  <p className="text-sm text-muted-foreground line-clamp-2 mt-1">{c.subtitle || c.description}</p>
                </div>
                <div className="flex items-center gap-4 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1"><User className="h-3 w-3" /> {c.instructor_name}</span>
                  <span className="flex items-center gap-1"><BookOpen className="h-3 w-3" /> {c.lessons_count} درس</span>
                  {c.duration_label && <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> {c.duration_label}</span>}
                </div>
                <div className="space-y-1">
                  <Progress value={c.progress_pct} />
                  <div className="text-xs text-muted-foreground">{c.progress_pct}% مكتمل</div>
                </div>
                <Link to={`/courses/${c.id}`}>
                  <Button className="w-full rounded-full" data-testid={`btn-open-course-${c.id}`}>
                    {c.progress_pct > 0 ? "أكمل الدورة" : "ابدأ الدورة"}
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
